import { outputDiv } from "commonAssets/js/constants";

const e = (selector) => document.querySelector(selector);
const ee = (selector) => document.querySelectorAll(selector);

export function jsbMedia() {
    let formObserver;

    $.getScript("https://www.googletagmanager.com/gtag/js?id=G-E34M1L0N50", () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());

        gtag('config', 'G-E34M1L0N50');
        gtag('config', 'G-KPG44P77JE'); // Google Analytics
        gtag('config', 'AW-10839088199'); // Search

        if (window.location.pathname === '/submit-claim') {
            gtag('event', 'conversion', { 'send_to': 'AW-10839088199/S-HVCOTLw5ADEMe4vbAo' });
            gtag('event', 'conversion', { 'send_to': 'AW-10839088199/S-HVCOTLw5ADEMe4vbAo' });
            twq('event', 'tw-o7f0u-ppmci', {
                conversion_id: null // use this to pass a unique ID for the conversion event for deduplication (e.g. order id '1a2b3c')
            });
        }

        // We'll use a mutation observer to detect when the form is added to the DOM
        // and then we'll add an event listener to the form
        formObserver?.disconnect();
        formObserver = new MutationObserver(handleMutations({ gtag }));
        formObserver.observe(outputDiv, {
            childList: true,
            subtree: true
        });

        // if path = /opt-out 
        if (window.location.pathname === "/opt-out") {
            function gtag_generate_lead() {
                if (e('#submit-claim')) {
                    e('#submit-claim').addEventListener('click', function () {
                        gtag("event", "generate_lead", {
                            currency: "USD",
                            value: 1
                        });

                        var img = document.createElement('img');
                        img.src = 'https://insight.adsrvr.org/track/pxl/?adv=383tufw&ct=0:hwu4b6u&fmt=3';
                        img.style = 'border-style:none;';
                        img.alt = '';
                        img.height = 1;
                        img.width = 1;
                        document.body.appendChild(img);

                        return;
                    });
                } else {
                    setTimeout(gtag_generate_lead, 500);
                }
            }
            gtag_generate_lead();
        }
    });

    $.getScript("https://js.adsrvr.org/up_loader.1.1.0.js", () => {
        ttd_dom_ready(function () {
            if (typeof TTDUniversalPixelApi === 'function') {
                var universalPixelApi = new TTDUniversalPixelApi();
                universalPixelApi.init("383tufw", ["is5ziyh"], "https://insight.adsrvr.org/track/up");
            }
        });
    });

    if (e('img[src="https://insight.adsrvr.org/track/pxl/?adv=383tufw&ct=0:hwu4b6u&fmt=3"]')) {
        e('img[src="https://insight.adsrvr.org/track/pxl/?adv=383tufw&ct=0:hwu4b6u&fmt=3"]').remove();
    }

}

function handleMutations({ gtag }) {
    return (mutations) => {
        const addedNodes = mutations.filter(mutation => mutation.type === 'childList').flatMap(mutation => Array.from(mutation.addedNodes));
        const removedNodes = mutations.filter(mutation => mutation.type === 'childList').flatMap(mutation => Array.from(mutation.removedNodes));

        const handleSubmit = () => {
            gtag("event", "generate_lead", {
                currency: "USD",
                value: 1
            });
            fbq('track', 'Lead');
        };

        // Add the event listener to the form
        const addedForm = addedNodes.find(node => node.tagName === 'FORM' && node.id === 'form');
        if (addedForm) {
            addedForm.addEventListener('submit', handleSubmit);
            console.log('submit form event added');
            return;
        }

        // Remove the event listener from the form
        const removedContainer = removedNodes.find(node => node.tagName === 'DIV' && node.classList.contains('display-form'));
        if (removedContainer) {
            const removedForm = removedContainer.querySelector('form#form');
            if (removedForm) {
                removedForm.removeEventListener('submit', handleSubmit);
                console.log('submit form event removed');
            }
        }

    }
}